module.exports = __webpack_public_path__ + "img/grid-actions-img.a32240f4.svg";